export default __webpack_public_path__ + "static/media/question.892808ad.svg";